import { Typography } from 'antd';
import React, { useContext } from 'react'
import styled from 'styled-components';
import { MapContext } from '../../App/MapContextContainer';
import { useTranslation } from 'react-i18next';
import TranslatedOption from '../TranslatedOption/TranslatedOption';

const LegendColorBoxImg = styled.img`
    padding: 0 4px 0 0px;
`;

export default function Legend() {
    const { legendData } = useContext(MapContext);
    const { t, i18n } = useTranslation("sidePanelTabs");

    return (legendData && legendData.length > 0 && <>
        <Typography.Title level={4}>{t("mkiSelitteetOtsikko")}</Typography.Title>
        <div>
            {
                legendData.map((legendDataItem) => {
                    return <span key={legendDataItem.nameFi}>
                        <LegendColorBoxImg src={`data:image/png;base64,${legendDataItem.imageData}`}></LegendColorBoxImg>
                        <TranslatedOption toTranslate={legendDataItem} />
                        <br />
                    </span>
                })
            }
        </div> </>
    ) || <></>
}